import Vue from 'vue'
import Vuex from 'vuex'
import BaseAlert from '@/components/base/ui/BaseAlert.vue'
import microhabitsStore from '@/store/modules/microhabits'
import surveyStore from '@/store/modules/survey'
import sessionStore from '@/store/modules/session'
import videoStore from '@/store/modules/video'
import forumStore from '@/store/modules/forum'
import healthyHabitsStore from '@/store/modules/healthyHabits'
import signalRStore from '@/store/modules/signalr'
import testsStore from '@/store/modules/tests'
import notificationsStore from '@/store/modules/notifications'
import layoutStore from '@/store/modules/layout'
import chatStore from '@/store/modules/chat'
import vuexPersistence from '@/plugins/vuex-persistence'
import i18n from '@/plugins/i18n'

Vue.use(Vuex)
/* 
const MODULES_TO_PERSIST = ['session', 'video', 'food'] */

// In video module for example we don't want to persist the whole state
const STATE_REDUCER_FN = (state) => {
	// MODULES_NOT_TO_PERSIST: ['healthyHabits', 'forum', 'tests', 'signalR', 'layout'], foods is in ...rest object
	const { session, video, healthyHabits, forum, tests, signalr, notifications, layout, ...rest } = state
	// Only persist useLamp and useStethoscope from video module
	const { useLamp, useStethoscope } = video
	// Exclude sharedDialog and loading from global state
	const { sharedDialog, cookiesBannerVisible, loading, clinicHistory, ...restGlobal } = rest
	// Exclude logged from session module
  const { logged, loginCallback, ...restSession} = session
	// Exclude retrievedLiveStates, summary from notifications module
	const { retrievedLiveStates, summary, ...restNotifications } = notifications
	const reducedState =  { session: {...restSession}, video: { useLamp, useStethoscope }, notifications: { ...restNotifications }, ...restGlobal }
	return reducedState
}

export default new Vuex.Store({
	modules: {
		microhabits: microhabitsStore,
		survey: surveyStore,
		session: sessionStore,
		video: videoStore,
		forum: forumStore,
		healthyHabits: healthyHabitsStore,
    tests: testsStore,
		signalr: signalRStore,
		notifications: notificationsStore,
		layout: layoutStore,
    chat: chatStore
	},
	plugins: [vuexPersistence(STATE_REDUCER_FN).plugin],
  state () {
    return {
      loading: false,
      sharedDialog: {
				visible: false,
        title: null,
        content: '',
        okFn: () => {}
      },
      cookiesBannerVisible: true,
      errorPageMessage: null,
      clinicHistory: {
        sidebarHidden: true
      },
			smartsuppChatLoaded: false
    }
  },
  mutations: {
    setLoading (state, isLoading) {
      state.loading = isLoading
    },
    setSharedDialog (state, { content, okFn = null, okBtnText = null, size = 'md' }) {
      state.sharedDialog.content = content
      state.sharedDialog.okFn = okFn || function () {
        state.sharedDialog.visible = false
      }
			state.sharedDialog.okBtnText = okBtnText
      state.sharedDialog.visible = true
			state.sharedDialog.size = size
    },
    hideSharedDialog (state) {
      state.sharedDialog.visible = false
    },
		setSharedDialogVisible (state, visible) {
			state.sharedDialog.visible = visible
		},
    setCookiesBannerVisible (state, visible) {
      state.cookiesBannerVisible = visible
    },
    setErrorPageMessage (state, msg) {
      state.errorPageMessage = msg
    }
  },
  actions: {
		showSharedDialog ({ commit }, { content, okFn = null, okBtnText = null, size = 'md' }) {
			commit('setSharedDialog', { content, okFn, okBtnText, size})
		},
    showAlert (state, { text, variant }) {
      variant = variant || 'success'
      const BaseAlertClass = Vue.extend(BaseAlert)
      const baseAlertInstance = new BaseAlertClass({
        propsData: {
          value: true,
          variant: variant
        }
      })
      baseAlertInstance.$slots.default = [ text ]
      baseAlertInstance.$mount()
      document.getElementById('app').prepend(baseAlertInstance.$el)
    },
    showDangerAlert ({ dispatch }, text) {
      dispatch('showAlert', { text: text || i18n.t('errors.error-has-ocurred'), variant: 'danger' })
    },
    showSuccessAlert ({ dispatch }, text) {
      dispatch('showAlert', { text: text, variant: 'success' })
    },
    showInfoAlert ({ dispatch }, text) {
      dispatch('showAlert', { text: text, variant: 'info' })
    },
		showOnlySubscriptorsDialog ({ dispatch }) {
			dispatch('showSharedDialog', {
				content: i18n.t(`patient-panel.only-subscriptors-warning`),
				okBtnText: i18n.t('know-more'),
				size: 'sm'
			})
		}
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js